import React from 'react';
import { Formik, Form, Field } from 'formik';

export default function ForgottenPasswordResetForm(props) {
  const { onSubmit } = props;

  return (
    <Formik
      initialValues={{ password: '' }}
      onSubmit={onSubmit}
      render={({ values, errors, isSubmitting }) => (
        <Form>
          <h2 className="media__heading heading heading--3">Reset password</h2>
          <p>Please enter your new password</p>
          <Field
            className="form__control form__control--has-buttons"
            type="password"
            name="password"
            id="password"
            value={values.password}
            required
          />
          <div className="buttons">
            <button type="submit" className="button button--primary">
              Reset
            </button>
          </div>
        </Form>
      )}
    />
  );
}